import { ApolloClient, from, HttpLink, InMemoryCache, split } from "@apollo/client";
// import apolloLogger from 'apollo-link-logger';
import { getMainDefinition } from "@apollo/client/utilities";
import { createErrorHandlerLink } from "./errors";
import { createAuthLink } from "./auth";
import { wsLink } from "./webSocketLink";
import { TStore } from "../types";

const cache = new InMemoryCache();

const httpLink = new HttpLink({
    uri: "/api",
});

export const createClient = (store: TStore) => {
    return new ApolloClient({
        cache,
        link: from([
            createAuthLink(),
            createErrorHandlerLink(store),
            // TODO: if this is enabled, the websocket dies
            // apolloLogger,
            split(
                // split based on operation type
                ({ query }) => {
                    const definition = getMainDefinition(query);
                    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
                },
                wsLink,
                httpLink
            ),
        ]),
    });
};
